<a
  class="items-list-item dashboard-item-pos"
  [attr.aria-label]="'Consulter votre offre ' + offer.name"
  [attr.data-e2e]="'e2e-dashboard-offer'"
  (click)="extendedLinkService.openLink(offer.relation); (false)"
  [href]="extendedLinkService.getLink(offer.relation)"
>
  <div class="item-container dashboard-anchor">
    <div class="item-text">
      <span class="lead pt-0">
        <strong>{{ 'dashboard.offer' | translate }}</strong>
      </span>
      <small class="item-desc">{{ 'dashboard.offerLabel' | translate }}</small>
    </div>
  </div>
</a>
